"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.withClassNames = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var useClassNames_1 = require("./useClassNames");
function withClassNames(WrappedComponent) {
    return react_1.default.forwardRef(function (props, ref) {
        var teaClassNames = useClassNames_1.useClassNames();
        return react_1.default.createElement(WrappedComponent, tslib_1.__assign(tslib_1.__assign({}, props), { ref: ref,
            teaClassNames: teaClassNames }));
    });
}
exports.withClassNames = withClassNames;
//# sourceMappingURL=withClassNames.js.map